<template>
  <component :is="activeComponent"
             :token="token"/>
</template>

<script>
  import DRootMedicineOrderDetails from './d-root-medicine-order-details';
  import MRootMedicineOrderDetails from './m-root-medicine-order-details';

  export default {
    name: "root-medicine-order-details",
    props: {
      token: {type: String}
    },
    computed: {
      activeComponent() {
        return this.$isDesktop ? DRootMedicineOrderDetails : MRootMedicineOrderDetails;
      }
    },
  }
</script>

<style scoped>

</style>